<script>
    import { navigate } from "svelte-routing";
    import Conexoes from "../../../Classes/Conexoes";
    import Constantes from "../../../Classes/Constantes";
    import LoadingTela from "../../../componentes_basicos/LoadingTela.svelte";
    import CaixaDeDialogo from "../../../componentes_basicos/CaixaDeDialogo.svelte";

    export let id = "";
    export let navegacao = "";
    export let celulas;
    export let linha;
    export let chamaEdicao = true;
    export let tabela;
    export let podeDeletar=false;
    let conexao = new Conexoes();
    let message;
    let isLoading=false;
    function chamarEdicao(edicao) {
        if (edicao) {
            console.log("clicou " + id);
            navigate(navegacao + "?id=" + id);
        }
    }

    async function apagarItem(id) {
        isLoading=true;
        let result = await conexao.conecta(Constantes.api_editar_padrao,{
         tabela:tabela, 
         modo_code:'apagar',
         id_update: id
        }, null, Constantes.msg_confirma_apagar_dados)

        if(result && result.sucesso){
            message = Constantes.msg_apagados_sucesso;
            window.location.reload();
        }else{
            message = Constantes.msg_erro_conexao_bd;
        }
        isLoading=false;
    }
</script>
<LoadingTela {isLoading} />
<CaixaDeDialogo {message} on:close={()=>message=""}/>
<div class="linha">
    <button class="botao" on:click={() => chamarEdicao(chamaEdicao)}>
        {#each celulas as celula}
            {celula.rotulo}: {linha[celula.nomeColuna]}<br />
        {/each}
    </button>

    <!-- Botão de Lixeirinha -->
    {#if podeDeletar}
    <button class="botao-lixeira" on:click={() => apagarItem(id)}>
        <i class="fas fa-trash-alt"></i>
    </button>
    {/if}
</div>

<style>
    .linha {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 30%; /* Largura mínima */
        max-width: 100%; /* Largura máxima */
        width: fit-content; /* Ajusta a largura de acordo com o conteúdo */
    }

    button.botao {
        background-color: #fdfdfd; /* Botão transparente */
        border: none; /* Sem borda */
        padding: 10px; /* Espaçamento interno */
        cursor: pointer; /* Ícone de cursor de mão */
        transition: background-color 0.3s ease; /* Efeito de transição */
        border: 1px solid #ccc; /* Contorno sombreado */
        border-radius: 5px; /* Borda arredondada */
        text-align: left;
        flex-grow: 1; /* Ocupa o máximo de espaço possível */
    }

    button.botao:hover {
        background-color: #f0f0f0; /* Cor de fundo ao passar o mouse */
    }

    button.botao-lixeira {
        background-color: transparent; /* Sem fundo */
        border: none; /* Sem borda */
        color: #e74c3c; /* Cor do ícone */
        cursor: pointer;
        font-size: 1.2rem; /* Tamanho do ícone */
        margin-left: 10px;
    }

    button.botao-lixeira:hover {
        color: #c0392b; /* Cor ao passar o mouse */
    }

    .fas.fa-trash-alt {
        pointer-events: none; /* Evita que o clique seja no ícone, mantendo no botão */
    }
</style>
